import { ROLES, isSuperAdminOrOwner } from '@jira-clone/shared-types'
import { useAuth } from '../../context/AuthContext'
import { usePermissions } from './usePermissions'

/**
 * What a user may do with the Space (project) behind a deal.
 *
 * - canCreateSpace mirrors the API rule for creating a project: the
 *   PROJECTS.CREATE permission and an Owner/Admin (or Superadmin) role, so the
 *   Create Space buttons never show to someone who would only get "Forbidden".
 * - canViewSpace is Superadmin/Owner only: the "View Space" shortcut from a deal
 *   is for them, not for sales reps.
 */
export function useDealSpaceAccess() {
  const { user } = useAuth()
  const { can } = usePermissions()

  const isSuperadmin = isSuperAdminOrOwner(user?.role)
  const isAdminTier = isSuperadmin || user?.role === ROLES.ADMIN

  return {
    canCreateSpace: can('PROJECTS', 'CREATE') && isAdminTier,
    canViewSpace: isSuperadmin,
  }
}
